export default __webpack_public_path__ + "static/f275eebe-30f5-4068-9294-51dc44c8409e-e2bb37730163b21ee09f45d158e3f693.ttf";